import React, { useContext, useMemo, useState } from 'react';
import CardBox from '../../../CardBox';
import { Button, Empty } from '@maxtropy/components';
import { DoubleRightOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import IncomeAnalysisModal from '@/pages/IndustrialGreenMicBigScreen/IncomeAnalysisModal';
import { useRequest } from 'ahooks';
import { apiV2MicrogridOverviewGetProfitDataPost } from '@maxtropy/intelligent-dispath-apis-v2';
import { ShareDataContext } from '@/pages/IndustrialGreenMicBigScreen';
import { keepPercentTwoLine, keepTwoOrLine } from '@/pages/IndustrialGreenMicBigScreen/utils';
import { isNil } from 'lodash-es';
import CustomTooltip from '../../../CustomTooltip';
import ReactEcharts from 'echarts-for-react';
import { getChartOption } from './chart';
import { Spin } from 'antd';

const BeneficialData = () => {
  const { microgridId } = useContext(ShareDataContext);
  const [visible, setVisible] = useState<boolean>(false);

  // 收益数据
  const { data, loading } = useRequest(
    () => {
      return apiV2MicrogridOverviewGetProfitDataPost({
        id: microgridId,
      });
    },
    {
      ready: !!microgridId,
      refreshDeps: [microgridId],
      pollingInterval: 1000 * 60 * 15,
    }
  );

  // 查询图表
  const chartOption = useMemo(() => getChartOption(data), [data]);

  // 判断是否都为空，如果都为空则显示empty
  const isShowEmpty = useMemo(() => {
    if (data?.detail?.length) {
      return false;
    }
    return true;
  }, [data]);

  return (
    <CardBox
      title="收益数据"
      extraContent={
        <Button
          type="link"
          style={{ padding: '0' }}
          onClick={() => {
            setVisible(true);
          }}
        >
          收益分析
          <DoubleRightOutlined className={styles.translationStyles} />
        </Button>
      }
    >
      <div className={styles.top_box}>
        <div className={styles.item}>
          <div className={styles.left_box}>
            <div className={styles.label}>昨日收益(元)</div>
            <CustomTooltip title={`${keepTwoOrLine(data?.lastValue)}`}>
              <div className={styles.value}>{keepTwoOrLine(data?.lastValue)}</div>
            </CustomTooltip>
          </div>
          <div className={styles.dash_line}></div>
          <div className={styles.right_box}>
            <div className={styles.label}>环比</div>
            <CustomTooltip title={`${keepPercentTwoLine(data?.dayChainBase)}%`}>
              <div className={styles.value} style={{ fontFamily: 'PingFangSC, PingFang SC' }}>
                {formatMomRatio(data?.dayChainBase)}
              </div>
            </CustomTooltip>
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.left_box}>
            <div className={styles.label}>本月收益(元)</div>
            <div className={styles.value}>{keepTwoOrLine(data?.currentValue)}</div>
          </div>
          <div className={styles.right_box}>
            <div className={styles.label}>环比</div>
            <div className={styles.value} style={{ fontFamily: 'PingFangSC, PingFang SC' }}>
              {formatMomRatio(data?.monthChainBase)}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.echartWrapper}>
        {loading ? (
          <Spin spinning={true} />
        ) : isShowEmpty ? (
          <Empty className={styles.empty_box} />
        ) : (
          <ReactEcharts style={{ width: '100%', height: '100%' }} option={chartOption} notMerge lazyUpdate={false} />
        )}
      </div>
      {visible && <IncomeAnalysisModal visible={visible} setVisible={setVisible}></IncomeAnalysisModal>}
    </CardBox>
  );
};

export default BeneficialData;

export function formatMomRatio(num?: number | null) {
  if (isNil(num)) return <span style={{ color: 'rgba(255,255,255,.85)' }}>--</span>;
  return num > 0 ? (
    <span style={{ color: '#59D744' }}>+{Number((num * 100).toFixed(2))}%</span>
  ) : num === 0 ? (
    <span style={{ color: 'rgba(255,255,255,.85)' }}>0%</span>
  ) : (
    <span style={{ color: '#FF4D4F' }}>{Number((num * 100).toFixed(2))}%</span>
  );
}
